import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { api } from "@/lib/api";
import ServiceCard from "@/components/ServiceCard";

const ORDER = ["all", "cashback", "reward-apps", "card-tools", "surveys"];
const LABELS = {
  all: "All services",
  cashback: "Cashback Sites",
  "reward-apps": "Reward Apps",
  "card-tools": "Card Tools",
  surveys: "Survey Panels",
};

export default function Directory() {
  const [services, setServices] = useState([]);
  const [params, setParams] = useSearchParams();
  const cat = params.get("cat") || "all";

  useEffect(() => {
    api.get("/services").then((r) => setServices(r.data));
  }, []);

  const filtered = cat === "all" ? services : services.filter((s) => s.category === cat);

  return (
    <main data-testid="directory-page">
      <section className="relative overflow-hidden">
        <div className="mds-container pt-14 pb-8">
          <span className="mds-badge">Directory</span>
          <div className="mt-4 grid grid-cols-1 lg:grid-cols-12 gap-8 items-end">
            <div className="lg:col-span-8">
              <h1 className="font-heading font-semibold text-4xl sm:text-5xl tracking-tight leading-tight">
                Every service, honestly reviewed.
              </h1>
              <p className="text-[#4A5D54] mt-4 max-w-2xl leading-relaxed">
                Filter by category and dive into any service. Every link is my personal referral — if you sign up, you help support the site (and often get a joining bonus too).
              </p>
            </div>
            <div className="lg:col-span-4">
              <div className="rounded-2xl overflow-hidden border border-[#E5E3DB]">
                <img
                  src="https://images.unsplash.com/photo-1727407209320-1fa6ae60ee05?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njd8MHwxfHNlYXJjaHwyfHx1c2luZyUyMHNtYXJ0cGhvbmUlMjBzaG9wcGluZyUyMG1vZGVybnxlbnwwfHx8fDE3ODMzNDY4Nzl8MA&ixlib=rb-4.1.0&q=85"
                  alt="Shopping"
                  className="w-full h-40 object-cover"
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="mds-container">
        <div className="flex flex-wrap gap-2 border-b border-[#E5E3DB] pb-4 mb-10">
          {ORDER.map((k) => (
            <button
              key={k}
              onClick={() => setParams(k === "all" ? {} : { cat: k })}
              data-testid={`filter-${k}`}
              className={`px-4 py-2 rounded-full text-sm font-medium transition-all border ${
                cat === k
                  ? "bg-[#84A98C] text-white border-transparent"
                  : "bg-white text-[#4A5D54] border-[#E5E3DB] hover:border-[#84A98C]"
              }`}
            >
              {LABELS[k]}
            </button>
          ))}
        </div>

        {filtered.length === 0 ? (
          <p className="text-[#7A8C84]">Loading services…</p>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 pb-16">
            {filtered.map((s, i) => <ServiceCard key={s.id} service={s} index={i} />)}
          </div>
        )}
      </section>
    </main>
  );
}
